const store = require('@/store').default
const bus = require('@/utils/bus').default
const {
	customerDetailPath,
	buildCustomerDetailQuery,
	buildCustomerDetailTabKey,
	saveCustomerDetailNeighborContext,
	clearCustomerDetailNeighborContext
} = require('@/utils/routeTab')

const publicFunc = {
	// 打开弹窗
	handleOpenModal(type, text, data) {
		console.log(type, text, data)
		this.$refs[type].openModal(text, data)
	},
	// 处理掉三级联动的最后一级数据
	filterThirdLevel(nodes) {
		// 深拷贝，避免修改原始数据
		const newNodes = JSON.parse(JSON.stringify(nodes));

		return newNodes.map(node => {
			// 1. 如果是二级节点（level=2），清空children（移除三级节点）
			if (node.level === 2) {
				delete node.children;
			}
			// 2. 如果是一级节点（level=1），递归处理其子节点
			else if (node.level === 1 && node.children && node.children.length > 0) {
				node.children = this.filterThirdLevel(node.children);
			}
			// 3. 过滤掉三级节点（防止漏网）
			return node.level !== 3 ? node : null;
		}).filter(Boolean); // 移除null值（即level=3的节点）
	},
	// 处理掉没有数据的children
	cleanEmptyChildren(tree) {
		if (!Array.isArray(tree)) return [];
		// console.log(tree, '这是要处理的数据');
		return tree.map(item => {
			// 先深拷贝一份，避免修改原数据
			const newItem = {
				...item
			};
			// 如果有 children，递归处理
			if (newItem.children) {
				// 递归处理子级
				newItem.children = this.cleanEmptyChildren(newItem.children);
				// 处理完后，如果子级为空 → 删除 children 属性
				if (newItem.children.length === 0) {
					delete newItem.children;
				}
			} else {
				// 没有 children 或者为 null/undefined → 直接删除
				delete newItem.children;
			}
			return newItem;
		});
	},
	// 时间筛选
	handleFilterTime(type) {
		if (type == 0) {
			const yesterday = this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
			return [yesterday, yesterday]
		}
		// 今天 type=1
		if (type == 1) {
			const today = this.$moment().format('YYYY-MM-DD');
			return [today, today]
		}
		// 本周 type=2
		if (type == 2) {
			const thisWeekStartDefault = this.$moment().startOf('week').format('YYYY-MM-DD'); // 本周开始（周日）
			const thisWeekEndDefault = this.$moment().endOf('week').format('YYYY-MM-DD'); // 本周结束（周六）
			// console.log('本周开始(周日):', thisWeekStartDefault.format('YYYY-MM-DD'));
			// console.log('本周结束(周六):', thisWeekEndDefault.format('YYYY-MM-DD'));
			return [thisWeekStartDefault, thisWeekEndDefault]
		}
		// 本月 type=3
		if (type == 3) {
			const thisMonthStart = this.$moment().startOf('month').format('YYYY-MM-DD'); // 本月开始
			const thisMonthEnd = this.$moment().endOf('month').format('YYYY-MM-DD'); // 本月结束
			// console.log('本月开始:', thisMonthStart.format('YYYY-MM-DD'));
			// console.log('本月结束:', thisMonthEnd.format('YYYY-MM-DD'));
			return [thisMonthStart, thisMonthEnd]
		}
		// 上月 type=4
		if (type == 4) {
			const lastMonthStart = this.$moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'); // 上月开始
			const lastMonthEnd = this.$moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'); // 上月结束
			// console.log('上月开始:', lastMonthStart.format('YYYY-MM-DD'));
			// console.log('上月结束:', lastMonthEnd.format('YYYY-MM-DD'));
			return [lastMonthStart, lastMonthEnd]
		}
	},
	// 线索状态筛选
	handleFilterState(state) {
		let arr = ['新数据未处理', '待跟进', '待签约', '已上门', '已签约', '已放款', '未分配', '审件中', '办理中', '已邀约']
		return arr[state + 1];
	},
	// 根据线索状态返回数据颜色
	// 新数据(-1)红色；有重复申请时间时：仅当未跟进(lastFollowUpTime空)或跟进早于重复申请时红色
	handleFilterColor(record) {
		if (!record) return ''
		if (record.state == -1) {
			return 'text-red'
		}
		if (!record.repeatApplyTime) {
			return ''
		}
		// 未跟进：重复申请后标红
		if (!record.lastFollowUpTime) {
			return 'text-red'
		}
		const lastFollow = new Date(record.lastFollowUpTime).getTime()
		const repeatApply = new Date(record.repeatApplyTime).getTime()
		if (!Number.isNaN(lastFollow) && !Number.isNaN(repeatApply) && lastFollow < repeatApply) {
			return 'text-red'
		}
		return ''
	},
	// 线索状态 tag 颜色：新数据(-1) 红色，其余蓝色
	handleFilterStateTagColor(state) {
		return Number(state) === -1 ? 'red' : 'blue'
	},
	// 编号排序
	getNumberFromCode(code) {
		// 判空处理：避免编号为空时报错
		if (!code) return 0;
		// 正则匹配所有数字字符，拼接后转数值
		const numStr = code.replace(/\D/g, '');
		return Number(numStr);
	},

	// 数量加
	handleNumPlus(num) {
		return Number(num) + 1
	},
	// 数量减
	handleNumReduce(num) {
		return (Number(num) > 0) ? (Number(num) - 1) : 0
	},
	// 业绩状态列表
	handlePerformanceStatus(num) {
		// 0-待审批 1-审批通过 2-拒绝 3-主管审批中 4-后勤审批中
		const arr = ['待审批', '审批通过', '拒绝', '主管审批中', '后勤审批中'];
		return arr[num]
	},
	// 业绩状态列表色系过滤
	handlePerformanceStatusColor(num) {
		// 0-待审批 1-审批通过 2-拒绝 3-主管审批中 4-后勤审批中
		const arr = ['blue', 'green', 'red', 'orange', 'cyan'];
		return arr[num]
	},
	// 格式过滤
	handleFotmatFilter(value, type) {
		if ('phone' === type) {
			return /^1[3-9]\d{9}$/.test(value);
		}
		if ('email' === type) {
			return /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/.test(value);
		}
		if ('idcard' === type) {
			var checkProv = function(val) {
				var pattern = /^[1-9][0-9]/;
				var provs = {
					11: "北京",
					12: "天津",
					13: "河北",
					14: "山西",
					15: "内蒙古",
					21: "辽宁",
					22: "吉林",
					23: "黑龙江 ",
					31: "上海",
					32: "江苏",
					33: "浙江",
					34: "安徽",
					35: "福建",
					36: "江西",
					37: "山东",
					41: "河南",
					42: "湖北 ",
					43: "湖南",
					44: "广东",
					45: "广西",
					46: "海南",
					50: "重庆",
					51: "四川",
					52: "贵州",
					53: "云南",
					54: "西藏 ",
					61: "陕西",
					62: "甘肃",
					63: "青海",
					64: "宁夏",
					65: "新疆",
					71: "台湾",
					81: "香港",
					82: "澳门"
				};
				if (pattern.test(val))
					if (provs[val]) return true;
				return false;
			}
			var checkDate = function(val) {
				var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
				if (pattern.test(val)) {
					var year = val.substring(0, 4);
					var month = val.substring(4, 6);
					var date = val.substring(6, 8);
					var date2 = new Date(year + "-" + month + "-" + date);
					if (date2 && date2.getMonth() == (parseInt(month) - 1)) return true;
				}
				return false;
			}
			var checkCode = function(val) {
				var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
				var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
				var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
				var code = val.substring(17);
				if (p.test(val)) {
					var sum = 0;
					for (var i = 0; i < 17; i++) {
						sum += val[i] * factor[i];
					}
					if (parity[sum % 11] == code.toUpperCase()) {
						return true;
					}
				}
				return false;
			}
			var checkID = function(val) {
				if (checkCode(val)) {
					var date = val.substring(6, 14);
					if (checkDate(date)) {
						if (checkProv(val.substring(0, 2))) {
							return true;
						}
					}
				}
				return false;
			}
			return checkID(value + '');
		}
	},
	// 城市下的公司列表数据处理成统一格式
	handleCityCompanyfilter(arr) {
		arr.map(item => {
			if (item.cityName && item.cityId) {
				item.value = item.cityId;
				item.label = item.cityName;
			}
			if (item.companyList.length > 0) {
				item.companyList.map(item1 => {
					item1.label = item1.companyName;
					item1.vallue = item1.id;
				})
			}
		})
		return arr;
	},
	// 在职状态过滤
	handleEmploymentFiter(status) {
		let arr = this.employmentStatus.map(item => item.label);
		// console.log(!status)
		return status != null ? arr[status] : arr[5]
	},
	// 在职状态颜色过滤
	handleEmploymentFiterColor(status) {
		// console.log(status)
		let arr = ['blue', '#000', 'red', 'red', '#FFA500', 'green', 'red', '#FFA500']
		return status != null ? arr[status] : arr[5]
	},
	// 男女过滤
	handleSexFilter(status) {
		return status == 1 ? '女' : '男'
	},
	handleGoodNewFilter(status) {
		let arr = this.goodNewsType.map(item => item.label);
		return arr[status]
	},
	// 
	handleUpDoorfilter(status) {
		let arr = this.upDoorConclusion.map(item => item.label);
		return arr[status]
	},
	// 短信验证状态验证
	handleVerificationfilter(status) {
		let arr = this.receiveStatus.map(item => item.label);
		return arr[status]
	},
	// 短信类型校验
	handleSmsTypeFilter(status) {
		let arr = this.smsType.map(item => item.label);
		return arr[status - 1]
	},

	// 合同进展状态筛选
	handleContractStatus(status) {
		let arr = this.contractprogress.map(item => item.label);
		return arr[status]
	},
	// 合同进展状态筛选颜色
	handleContractStatusColor(status) {
		let arr = this.contractprogress.map(item => item.color);
		return arr[status]
	},
	// 无效申请过滤
	handleInvalidFilter(status) {
		let arr = this.invalidReasonList.map(item => item.label);
		return arr[status] ? arr[status] : ''
	},
	// 人员状态
	handleevaluationfilter(num){
		let arr = this.exceptionList.map(item => item.label)
		return arr[num] 
	},
	// 从列表数据中提取当前页客户 id
	extractCustomerListIds(listData) {
		if (!Array.isArray(listData) || !listData.length) {
			return []
		}
		if (listData[0] != null && typeof listData[0] === 'object') {
			return listData
				.map(item => String(item.id != null ? item.id : item.customerId))
				.filter(Boolean)
		}
		return listData.map(item => String(item)).filter(Boolean)
	},
	handleOpenPage(id, status, listData, page, pageNum, customerName) {
		// listData：当前页列表数据（tableData），从中提取 id 拼接到详情链接
		// page 当前页数
		// pageNum 当前每页条数
		// customerName 顶部 tab 显示的客户名称
		// 非邻接接口列表：走 ids 上下翻页，清理邻接上下文避免串模式
		clearCustomerDetailNeighborContext()
		const listIds = this.extractCustomerListIds(listData)
		const currentId = String(id)
		if (listIds.length) {
			const index = listIds.indexOf(currentId)
			this.$store.commit('SET_CUSTMOER_LIST', listIds)
			this.$store.commit('SET_NEWINDEX', index >= 0 ? index : 0)
			if (page != null) {
				this.$store.commit('SET_NEWPAGE', page)
			}
		}
		const query = buildCustomerDetailQuery({
			id: currentId,
			pageType: status,
			ids: listIds
		})
		return this.$router.push({
			path: customerDetailPath,
			query
		}).then(() => {
			if (customerName && this.$multiTab) {
				this.$nextTick(() => {
					const tabKey = buildCustomerDetailTabKey(query)
					this.$multiTab.rename(tabKey, customerName)
				})
			}
		})
	},
	handleJumpDetail(id, status, params, customerName, listApi) {
		// listApi: customer | all | team | reviewed，对应不同上下邻接口
		const currentId = String(id)
		const searchPayload = params && typeof params === 'object'
			? {
				...params,
				starRating: Array.isArray(params.starRating)
					? params.starRating.join(',')
					: params.starRating
			}
			: params
		const query = buildCustomerDetailQuery({
			id: currentId,
			pageType: status,
			searchData: searchPayload,
			listApi
		})
		saveCustomerDetailNeighborContext({
			listApi,
			searchData: searchPayload,
			pageType: status
		})
		return this.$router.push({
			path: customerDetailPath,
			query
		}).then(() => {
			if (customerName && this.$multiTab) {
				this.$nextTick(() => {
					const tabKey = buildCustomerDetailTabKey(query)
					this.$multiTab.rename(tabKey, customerName)
				})
			}
		})
	},
	// 过滤数组返回父级id 
	handleGresonFilter(id, tree, idKey = 'id', childKey = 'children') {
		if (Array.isArray(id)) {
			return id
		}
		const result = []
		// 递归查找节点 & 收集路径
		function findNode(nodes, targetId) {
			for (const node of nodes) {
				if (node[idKey] === targetId) {
					result.unshift(node[idKey])
					return true
				}
				if (node[childKey] && node[childKey].length) {
					if (findNode(node[childKey], targetId)) {
						result.unshift(node[idKey])
						return true
					}
				}
			}
			return false
		}
		findNode(tree, id)
		return result
	},
	getMobileTopToDown(tree, targetId) {
		let path = [];
		const target = targetId == null ? '' : String(targetId)

		function dfs(nodes) {
			for (const node of nodes) {
				// 选中值用 nodeValue（人员=手机号）；兼容旧字段 mobile
				path.push(node.nodeValue != null ? node.nodeValue : node.mobile);

				// 找到目标节点，直接返回
				if (String(node.id) === target) {
					return true;
				}
				// 递归子节点
				if (node.children && node.children.length) {
					if (dfs(node.children)) {
						return true;
					}
				}
				// 回溯，不是目标分支就删掉
				path.pop();
			}
			return false;
		}

		const hasFind = dfs(tree);
		return hasFind ? path : [];
	},
	// 传入：树形数组 nodes + 目标id
	// 返回：从顶层到目标id 的完整路径数组（包含每一级节点）
	getPathIdsFromTopToTarget(nodes, targetId) {
		let path = [];
		const dfs = (list) => {
			for (const node of list) {
				path.push(node.id);
				if (node.id === targetId) return true;
				if (node.children && dfs(node.children)) return true;
				path.pop();
			}
			return false;
		};
		dfs(nodes);
		return path;
	},
	async handleCopy(val) {
		try {
			await navigator.clipboard.writeText(val)
			this.$message.success('已复制')
		} catch (e) {
			// 降级兼容
			let input = document.createElement('textarea');
			input.value = val;
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
			this.$message.success('已复制');
		}
	},
	handleBtnsPerfilter(arr, id) {
		const targetId = String(id)
		// 过滤掉 __ob__ 等响应式属性，纯数组判断
		return arr.some(item => String(item) === targetId)
	},
	/**
	 * 按钮权限（数据来自登录时 getRouters 写入的 store，页面不再重复请求）
	 * 用法：v-if="hasButtonPermission('2989')"
	 */
	hasButtonPermission(id) {
		const { checkButtonPermission } = require('@/utils/buttonPermission')
		return checkButtonPermission(id)
	},
	// 业务经理多选：同步全选状态
	handleSelectManage(checkedValues) {
		const list = this.accountManage || []
		this.allChange = checkedValues.length > 0 && checkedValues.length === list.length
	},
	// 业务经理多选：全选 / 反选
	handleAllChange(e) {
		const checked = e.target.checked
		const list = this.accountManage || []
		this.allChange = checked
		this.selectManage = checked ? list.map(item => item.id) : []
	},
	// 业务经理名称样式
	getManagerNickStyle(item, width = '50px') {
		return {
			display: 'inline-block',
			width,
			fontSize: '10px',
			color: Number(item && item.isFull) === 1 ? '#ff4d4f' : ''
		}
	},
	
	// 手机号隐藏中间四位
	hidePhone(phone) {
	  if (!phone || phone.length !== 11) return phone;
	  return phone.slice(0, 3) + '****' + phone.slice(7);
	},
	// 刷新左侧客户菜单角标
	refreshMenuBadgeCount() {
		bus.$emit('refreshMenuBadgeCount')
		return store.dispatch('menu/fetchCustomerMenuBadgeCounts')
	},
	yuanToWanFixed(str, digit = 2) {
	  const num = Number(str);
	  const wanNum = (num / 10000).toFixed(digit);
	  return wanNum + '万元';
	},
	// 点评推送时线索名称截取
	getUserName(text) {
	  // 匹配 对(用户名)用户线索点评
	  const reg = /^对(.+)用户线索点评$/;
	  const match = text.match(reg);
	  return match ? match[1] : '';
	},
	/** 客户管理 / 租户管理列表默认每页条数（仅新开页读取，已开 Tab 不强制同步） */
	getDefaultPageSize() {
		const stored = Number(this.$store && this.$store.state.app && this.$store.state.app.listPageSize)
		if (stored > 0) {
			return stored
		}
		const options = this.pageSizeOptions
		if (Array.isArray(options) && options.length) {
			return Number(options[0]) || 15
		}
		return 15
	},
	/** 切换每页条数时写入全局偏好（localStorage），供后续新开页使用 */
	syncListPageSize(size) {
		const next = Number(size)
		if (!next || next < 1) {
			return
		}
		this.$store.commit('list_page_size', next)
	}
}

module.exports = publicFunc;